import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { CANONICAL_SALES_PATH } from "../../constants/salesRoutes";

const InfoLogin = (props) => {
  const { hideModal, showLogin } = props || {};
  const { t } = useTranslation();

  const handleSubscribe = () => {
    hideModal?.();
  };

  return (
    <div className="login-modal-holder">
      <div className="login-modal-title">
        <h1>{t("global.loginTitle2")}</h1>
        <div className="login-modal-close-icon" onClick={hideModal}>
          <img src="/images/close.png" alt="close" className="img-fluid" />
        </div>
      </div>

      <div className="login-modal-container">
        <div className="login-modal-form">
          <div className="info-login-subtitle">
            {t("error.loginRequiredMessage")}
          </div>

          <div className="info-login-buttons">
            <Link to={CANONICAL_SALES_PATH} onClick={handleSubscribe}>
              {t("subscription.subscribeCta")}
            </Link>
            <button className="secondary" onClick={showLogin}>
              {t("global.login")}
            </button>
          </div>
        </div>

        <div className="login-modal-banner">
          <img src="/images/logo-login-kat.png" alt="" className="img-fluid" />
        </div>
      </div>
    </div>
  );
};

export default InfoLogin;
